import R from 'ramda';
import React, { Component } from 'react';
import { Row, Col, FormGroup, Radio } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { getMemberNameByUserId } from '../../utils';
import getContent from '../ContractBlock/Contents/Indemnification';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Indemnification extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    field1: this.state.changes.field1,
    field2: this.state.changes.field2,
    name: this.state.changes.name || '',
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(index) {
    const options = this.options();
    options.field1 = index;

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  handleMembers(e) {
    const options = this.options();

    options.field1 = 1;
    options.field2 = e.target.value;
    options.name = e.target.options[e.target.selectedIndex].text;
    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderOriginal() {
    const { work, members } = this.props;

    if (this.props.field1 === 0) {
      return `Each collaborator will indemnify the others against third party legal claims arising out of their breach of this agreement.`;
    } else if (this.props.field1 === 1) {
      if (work && work.work_ownership_info) {
        const index = R.findIndex(
          R.propEq('user', parseInt(this.props.field2, 10))
        )(work.work_ownership_info);
        if (index !== -1) {
          const name = getMemberNameByUserId(
            parseInt(this.props.field2, 10),
            members
          );
          return `${name} will indemnify the other collaborators and cover any losses caused by their individual actions or third party legal actions against them.`;
        }
      }
    } else if (this.props.field1 === 2) {
      return `No indemnification.`;
    }

    return null;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;
    const { work, members } = this.props;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Radio
              name="indemnification"
              checked={changes.field1 === 0}
              readOnly
              onClick={(e) => this.handleContent(0)}
            >
              Each collaborator will indemnify the others against third party
              legal claims arising out of their breach of this agreement.
            </Radio>
            <Radio
              name="indemnification"
              checked={changes.field1 === 1}
              readOnly
              onClick={(e) => this.handleContent(1)}
            >
              <Select
                className="select-mini"
                value={changes.field2}
                onChange={(e) => this.handleMembers(e)}
              >
                <option value="">Select Member</option>
                {work &&
                  work.work_ownership_info &&
                  work.work_ownership_info.map((member, i) => (
                    <option key={i} value={member.user}>
                      {getMemberNameByUserId(member.user, members)}
                    </option>
                  ))}
              </Select>
              will indemnify the other collaborators and cover any losses caused
              by their individual actions or third party legal actions against
              them.
            </Radio>
            <Radio
              name="indemnification"
              checked={changes.field1 === 2}
              readOnly
              onClick={(e) => this.handleContent(2)}
            >
              No indemnification.
            </Radio>
          </FormGroup>
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    const { work, members } = this.props;

    if (changeRequest.changes.field1 === 0) {
      return `Each collaborator will indemnify the others against third party legal claims arising out of their breach of this agreement.`;
    } else if (changeRequest.changes.field1 === 1) {
      if (work && work.work_ownership_info) {
        const index = R.findIndex(
          R.propEq('user', parseInt(changeRequest.changes.field2, 10))
        )(work.work_ownership_info);
        if (index !== -1) {
          const name = getMemberNameByUserId(
            parseInt(changeRequest.changes.field2, 10),
            members
          );
          return `${name} will indemnify the other collaborators and cover any losses caused by their individual actions or third party legal actions against them.`;
        }
      }
    } else if (changeRequest.changes.field1 === 2) {
      return `No indemnification.`;
    }

    return `None`;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                Will any collaborator indemnify another collaborator?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="indemnification-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  <div className="pt-7px">{this.renderOriginal()}</div>
                </Radio>
                <hr />
                <Radio
                  name="indemnification-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  Things can go wrong. When this happens, this clause provides
                  guidelines for the protection of collaborators who are not at
                  fault and the responsibilities of the collaborators who are at
                  fault.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is indemnification?</p>
                <p className="small">
                  “Indemnification” is a promise by one party to cover the
                  losses another party may suffer because of third party legal
                  action taken against them as a result of the indemnifying
                  party’s breach of the agreement.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Indemnification.jsx